// 2.1 3x3ブロック/マスの画面配置マッピング
export const PRIORITY_MAP = {
  CENTER: { row: 2, col: 2 },
  1: { row: 3, col: 2 }, // 真下
  2: { row: 2, col: 1 }, // 左
  3: { row: 1, col: 2 }, // 上
  4: { row: 2, col: 3 }, // 右
  5: { row: 3, col: 1 }, // 左下
  6: { row: 1, col: 1 }, // 左上
  7: { row: 1, col: 3 }, // 右上
  8: { row: 3, col: 3 }, // 右下
};

export const BLOCK_TYPES = {
  CORE: 'CORE',
  BLOCK_1: 'BLOCK_1',
  BLOCK_2: 'BLOCK_2',
  BLOCK_3: 'BLOCK_3',
  BLOCK_4: 'BLOCK_4',
  BLOCK_5: 'BLOCK_5',
  BLOCK_6: 'BLOCK_6',
  BLOCK_7: 'BLOCK_7',
  BLOCK_8: 'BLOCK_8',
};

// CSS Gridの位置を計算するヘルパー
export const getGridArea = (is_center, priority_index) => {
  const pos = is_center ? PRIORITY_MAP.CENTER : PRIORITY_MAP[priority_index];
  if (!pos) return 'auto';
  return `${pos.row} / ${pos.col} / ${pos.row + 1} / ${pos.col + 1}`;
};